import { Spacing8, Spacing16, Spacing24, FontSize12 } from 'autogen/design-tokens/tokens';
import { rem } from 'modules/helpers/style';
import React from 'react';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';

const HeaderContainer = styled.div`
    margin-bottom: ${Spacing24};
`;

const Headline = styled.h3`
    font-size: ${rem(20)};
    line-height: ${rem(24)};
    margin-bottom: ${rem(Spacing8)};

    ${breakpoint.up(sizes.md)} {
        font-size: ${rem(32)};
        line-height: ${rem(40)};
        margin-bottom: ${rem(Spacing16)};
    }
`;

const SubHeadline = styled.p`
    font-size: ${FontSize12};
    line-height: ${rem(16)};
    margin-bottom: 0;
`;

interface IProps {
    headline: string;
    subHeadline: string;
}

export default function Header({ headline, subHeadline }: IProps): JSX.Element {
    return (
        <HeaderContainer>
            <Headline dangerouslySetInnerHTML={{ __html: headline }} />
            <SubHeadline>{subHeadline}</SubHeadline>
        </HeaderContainer>
    );
}
